export default __webpack_public_path__ + "static/media/PreviewDoorHangerTransparent.74d823ec.png";